import React, { forwardRef, useEffect, useRef, useState } from 'react';
import ptBR from 'date-fns/locale/pt-BR';
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import { Container, Content, DataFilter, Footer, Loader } from './styled';
import { IoMdCalendar, IoMdPhotos } from 'react-icons/io';
import imageCompression from 'browser-image-compression';
import { getBase64 } from '../../../Pages/Trade/Home/tradeGlobalFunctions';
import { alerta, getCurrentLocation, haveData } from '../../../services/funcoes';
import { Button } from 'react-materialize';
import { setLocalObject } from '../../../services/databaseLocal';
import api from '../../../services/api';
import { format } from 'date-fns';
import { Labels } from '../../../Pages/Trade/Home/style';
import { getFromStorage } from '../../../services/auth';

const CustomCalendarInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      width: '130px',
      justifyContent: 'space-around',
      borderBottom: '1px solid #ccc',
    }}
  >
    <InputMask
      style={{ width: '100px' }}
      mask="99/99/9999"
      value={value}
      maskChar={null}
      onChange={onChange}
      // onClick={onClick}
      // onBlur={(e) => this.handleValidarData(e, 'Data Inicial')}
    />
    <span onClick={onClick} style={{ cursor: 'pointer', color: 'rgb(97, 9, 138)' }}>
      <IoMdCalendar size={20} />
    </span>
  </div>
));

export function Hodometro({ handleClose, odometerData }) {
  const [startDate, setStartDate] = useState(new Date());
  const [imgInitial, setImgInitial] = useState({
    img: null,
    fileExtension: '',
  });
  const [imgFinal, setImgFinal] = useState({
    img: null,
    fileExtension: '',
  });
  const [loading, setLoading] = useState(false);
  const [dataOdometer, setDataOdometer] = useState(
    odometerData || {
      GKM_USR_AGENDA_ID: null,
      GKM_DATA: null,
      GKM_KM_INICIAL: null,
      GKM_KM_INICIAL_DATA: null,
      GKM_KM_INICIAL_FOTO: null,
      GKM_KM_INICIAL_LATITUDE: null,
      GKM_KM_INICIAL_LONGITUDE: null,
      GKM_KM_FINAL: null,
      GKM_KM_FINAL_DATA: null,
      GKM_KM_FINAL_FOTO: null,
      GKM_KM_FINAL_LATITUDE: null,
      GKM_KM_FINAL_LONGITUDE: null,
      GAA_KM_INICIAL: null,
      GAA_KM_FINAL: null,
    }
  );

  async function handleGetImage(event) {
    try {
      setLoading(true);
      const img = event.target.files[0];

      if (img) {
        const options = {
          maxSizeMB: 0.2,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        let compressedFile = await imageCompression(img, options);

        const fileExtension = compressedFile.name.substring(
          compressedFile.name.lastIndexOf('.'),
          compressedFile.name.length
        );

        const resData = await getBase64(compressedFile.size > img.size ? img : compressedFile);
        return { image: resData, fileExtension };
      }
    } catch (error) {
      alerta('Não foi possível salvar a imagem', 2);
    } finally {
      setLoading(false);
    }
  }

  async function handleSaveOdometro() {
    try {
      const sessao = getFromStorage();
      if (sessao) {
        setLoading(true);
        const { latitude, longitude } = await getCurrentLocation();

        if (!latitude || !longitude) {
          alerta('Não foi possível buscar a localização atual, tente novamente', 2);
          setLoading(false);
          return;
        }

        const empresaAtiva = sessao.empresaId;
        const usuarioAtivo = sessao.codigoUsuario;
        const empresaCnpj = sessao.empresaCnpj;


        if (
          !Number(dataOdometer.GAA_KM_INICIAL) &&
          Number(dataOdometer.GAA_KM_INICIAL) === 0 &&
          !dataOdometer.GAA_KM_FINAL &&
          dataOdometer.GAA_KM_FINAL === 0
        ) {
          alerta('Informe os dados do hodômetro', 2);
          return;
        }

        if (dataOdometer.GAA_KM_FINAL && dataOdometer.GAA_KM_FINAL < dataOdometer.GAA_KM_INICIAL) {
          alerta('A quilometragem do fim do dia não pode ser menor que a do início', 2);
          return;
        }

        if (!dataOdometer?.GKM_KM_INICIAL_FOTO && imgInitial.img) {
          dataOdometer.GKM_KM_INICIAL_FOTO = await handleSaveImage(
            imgInitial.img,
            `Foto_inicio${imgInitial.fileExtension}`,
            `km inicio dia`,
            usuarioAtivo,
            empresaCnpj
          );
        }

        if (!dataOdometer?.GKM_KM_FINAL_FOTO && imgFinal.img) {
          dataOdometer.GKM_KM_FINAL_FOTO = await handleSaveImage(
            imgFinal.img,
            `Foto_fim${imgFinal.fileExtension}`,
            `km fim dia`,
            usuarioAtivo,
            empresaCnpj
          );
        }

        if (dataOdometer?.GAA_KM_INICIAL && !dataOdometer.GKM_KM_INICIAL_FOTO) {
          alerta('Adicione a foto do início do dia', 2);
          return;
        }

        if (dataOdometer?.GAA_KM_FINAL && !dataOdometer.GKM_KM_FINAL_FOTO) {
          alerta('Adicione a foto do fim do dia', 2);
          return;
        }

        const payload = {
          GKM_USR_AGENDA_ID: usuarioAtivo,
          GKM_DATA: format(startDate, 'yyyy-MM-dd'),
          GKM_KM_INICIAL: dataOdometer?.GAA_KM_INICIAL,
          GKM_KM_INICIAL_DATA:
            dataOdometer?.GKM_KM_INICIAL_FOTO && !dataOdometer?.GKM_KM_INICIAL_DATA
              ? format(startDate, 'yyyy-MM-dd hh:mm:ss')
              : dataOdometer?.GKM_KM_INICIAL_DATA,
          GKM_KM_INICIAL_FOTO: dataOdometer.GKM_KM_INICIAL_FOTO,
          GKM_KM_INICIAL_LATITUDE:
            dataOdometer?.GKM_KM_INICIAL_FOTO && !dataOdometer?.GKM_KM_INICIAL_LATITUDE
              ? latitude
              : dataOdometer?.GKM_KM_INICIAL_LATITUDE,
          GKM_KM_INICIAL_LONGITUDE:
            dataOdometer?.GKM_KM_INICIAL_FOTO && !dataOdometer?.GKM_KM_INICIAL_LONGITUDE
              ? longitude
              : dataOdometer?.GKM_KM_INICIAL_LONGITUDE,
          GKM_KM_FINAL: dataOdometer?.GAA_KM_FINAL,
          GKM_KM_FINAL_DATA:
            dataOdometer?.GKM_KM_FINAL_FOTO && !dataOdometer?.GKM_KM_FINAL_DATA
              ? format(startDate, 'yyyy-MM-dd hh:mm:ss')
              : dataOdometer?.GKM_KM_FINAL_DATA,
          GKM_KM_FINAL_FOTO: dataOdometer.GKM_KM_FINAL_FOTO,
          GKM_KM_FINAL_LATITUDE:
            dataOdometer?.GKM_KM_FINAL_FOTO && !dataOdometer?.GKM_KM_FINAL_LATITUDE
              ? latitude
              : dataOdometer?.GKM_KM_FINAL_LATITUDE,
          GKM_KM_FINAL_LONGITUDE:
            dataOdometer?.GKM_KM_FINAL_FOTO && !dataOdometer?.GKM_KM_FINAL_LONGITUDE
              ? longitude
              : dataOdometer?.GKM_KM_FINAL_LONGITUDE,
        };
        const res = await api.post(`v2/trade/kmdriven/${empresaAtiva}/${usuarioAtivo}`, payload);

        const { sucess, data } = res.data;

        if (sucess) {
          let resData = data;
          if (Array.isArray(data)) {
            resData = data[0];
          }
          if (dataOdometer?.GKM_KM_FINAL_FOTO) {
            await setLocalObject('hodometroActive', false);
          } else {
            await setLocalObject('hodometroActive', true);
          }
          await setLocalObject('currentDrivenOdometro', resData);
          setDataOdometer(resData);
          handleClose();
          alerta('Salvo com sucesso', 1);
        }
      }
    } catch (error) {
      alerta('Não foi possível salvar', 2);
    } finally {
      setLoading(false);
    }
  }

  async function handleSaveImage(image, filename, uniqueid, usuarioAtivo, empresaCnpj) {
    try {
      const payload = {
        fileName: filename,
        id: 1,
        imageData: image,
        uniqueid,
      };

      const url = '/v2/trade/sync/image/' + empresaCnpj + '/' + usuarioAtivo;
      const res = await api.post(url, payload, {
        timeout: 30 * 1000,
      });

      const { data } = res.data;
      if (haveData(data)) {
        return data.urlPath;
      }
    } catch (error) {
      alerta('Não foi possível salvar a foto', 2);
    }
  }

  async function loadData(e) {
    try {
      setStartDate(e);
      const sessao = getFromStorage();
      if (sessao) {
        setLoading(true);
        const { latitude, longitude } = await getCurrentLocation();

        if (!latitude || !longitude) {
          alerta('Não foi possível buscar a localização atual, tente novamente', 2);
          setLoading(false);
          return;
        }

        const empresaAtiva = sessao.empresaId;
        const usuarioAtivo = sessao.codigoUsuario;

        const res = await api.get(`v2/trade/kmdriven/${empresaAtiva}/${usuarioAtivo}`, {
          params: {
            data: format(e, 'dd-MM-yyyy'),
            usuarioAgenda: usuarioAtivo,
          },
        });

        const { data } = res.data;

        if (data) {
          if (data && data.length > 0) {
            data[0].GAA_KM_INICIAL = data[0].GKM_KM_INICIAL;
            data[0].GAA_KM_FINAL = data[0].GKM_KM_FINAL;
            setImgInitial({ img: data[0].GKM_KM_INICIAL_FOTO, fileExtension: '' });
            setImgFinal({ img: data[0].GKM_KM_FINAL_FOTO, fileExtension: '' });
            setDataOdometer(data[0]);
            clearInputById("km_initial", data[0].GKM_KM_INICIAL)
            clearInputById("km_final", data[0].GKM_KM_FINAL)
          } else {
            setDataOdometer({
              GKM_USR_AGENDA_ID: null,
              GKM_DATA: null,
              GKM_KM_INICIAL: null,
              GKM_KM_INICIAL_DATA: null,
              GKM_KM_INICIAL_FOTO: null,
              GKM_KM_INICIAL_LATITUDE: null,
              GKM_KM_INICIAL_LONGITUDE: null,
              GKM_KM_FINAL: null,
              GKM_KM_FINAL_DATA: null,
              GKM_KM_FINAL_FOTO: null,
              GKM_KM_FINAL_LATITUDE: null,
              GKM_KM_FINAL_LONGITUDE: null,
              GAA_KM_INICIAL: null,
              GAA_KM_FINAL: null,
            });
            clearInputById("km_initial", "")
            clearInputById("km_final", "")
            setImgInitial({
              img: null,
              fileExtension: '',
            });
            setImgFinal({
              img: null,
              fileExtension: '',
            });
          }
        }
      }
    } catch (error) {
      alerta('Não foi possível buscar os dados desse dia', 2);
    } finally {
      setLoading(false);
    }
  }

  function clearInputById(id, value) {
    const inputElement = document.getElementById(id);
    if (inputElement && inputElement.type === "number") {
      inputElement.value = value;
    } else {
      console.error("O elemento não foi encontrado ou não é um input do tipo number");
    }
  }

  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    (async function load() {
      hasRun.current = true;
      loadData(new Date());
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      {loading && <Loader>Aguarde...</Loader>}
      <Content>
        <DataFilter>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ paddingLeft: '10px', color: '#000', fontSize: '1rem' }}>Data do hodômetro</label>
            <DatePicker
              id="startDate"
              selected={startDate}
              onChange={loadData}
              locale={ptBR}
              placeholderText="Data inicial"
              dateFormat="dd/MM/yyyy"
              selectsStart
              startDate={startDate}
              customInput={<CustomCalendarInput />}
            />
          </div>
        </DataFilter>

        <Labels color={'#000'} fontSize={'1.1rem'} style={{ marginTop: '0.4rem' }}>
          Km inicial do dia
        </Labels>
        <input
          id="km_initial"
          type="number"
          disabled={dataOdometer.GKM_KM_INICIAL}
          placeholder="Informe a KM inicial do dia"
          onChange={(e) => {
            dataOdometer.GAA_KM_INICIAL = Number(e.target.value) || '';
            setDataOdometer(dataOdometer);
          }}
          style={{ width: '95%' }}
        />
        <label
          htmlFor="inputPhoto"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            width: '98%',
            color: '#fff',
            fontSize: '1.2rem',
            padding: '0.3rem 0.5rem',
            background: '#8e44ad',
          }}
        >
          Foto do início do dia
          <IoMdPhotos size={20} />
        </label>

        <input
          className="hidden"
          id="inputPhoto"
          type="file"
          accept="image/*"
          disabled={dataOdometer.GKM_KM_INICIAL_FOTO}
          onChange={async (event) => {
            const res = await handleGetImage(event);
            if (res) {
              setImgInitial({
                img: res.image,
                fileExtension: res.fileExtension,
              });
            }
          }}
        />

        {imgInitial.img && <img src={imgInitial.img} alt="Foto saída" width={240} height={200} />}

        <Labels color={'#000'} fontSize={'1.1rem'} style={{ marginTop: '0.4rem' }}>
          Km final do dia
        </Labels>
        <input
          id="km_final"
          type="number"
          disabled={dataOdometer.GKM_KM_FINAL}
          placeholder="Informe a KM final do dia"
          onChange={(e) => {
            dataOdometer.GAA_KM_FINAL = Number(e.target.value) || '';
            setDataOdometer(dataOdometer);
          }}
          style={{ width: '95%' }}
        />

        <label
          htmlFor="inputPhotoFinal"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            width: '98%',
            color: '#fff',
            fontSize: '1.2rem',
            padding: '0.3rem 0.5rem',
            background: '#8e44ad',
            marginTop: '0.8rem',
          }}
        >
          Foto do fim do dia
          <IoMdPhotos size={20} />
        </label>

        <input
          className="hidden"
          id="inputPhotoFinal"
          type="file"
          accept="image/*"
          disabled={dataOdometer.GKM_KM_FINAL_FOTO}
          onChange={async (event) => {
            const res = await handleGetImage(event);
            if (res) {
              setImgFinal({
                img: res.image,
                fileExtension: res.fileExtension,
              });
            }
          }}
        />

        {imgFinal.img && <img src={imgFinal.img} alt="Foto saída" width={240} height={200} />}

        <Footer>
          <Button
            style={{ width: '35%' }}
            onClick={() => handleClose()}
            className="waves-effect waves-light saib-button is-secondary"
          >
            Fechar
          </Button>
          <Button
            onClick={handleSaveOdometro}
            style={{ width: '65%' }}
            disabled={dataOdometer.GKM_KM_INICIAL_FOTO && dataOdometer.GKM_KM_FINAL_FOTO}
            className="waves-effect waves-light saib-button is-primary"
          >
            SALVAR
          </Button>
        </Footer>
      </Content>
    </Container>
  );
}
